import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowLeft, Users, DollarSign, Video, ShoppingBag, BookOpen, Check, X, Upload, TrendingUp, Crown, Lock, Unlock, Settings, RefreshCw, Globe, Edit3, FileSpreadsheet, AlertCircle, Download, Youtube, Plus, Layers, Calendar, Flag, Star, Trash2, Gift, Ban, UserX, UserCheck, CheckCircle, ShieldCheck, Clock, PartyPopper, Archive } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Switch } from '../ui/switch';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Advertiser Products tab.
 *
 * Lifted out of AdminPanel.js during the Phase 2 frontend split (Wave 4).
 * Pure presentational — receives parent state + handlers via props.
 */
export default function AdvertisersTab(props) {
  const { user, navigate, getAuthHeader, fetchAllData, fileInputRef, users, setUsers, userSearch, setUserSearch, filteredUsers, pendingFounders, founderSettings, setFounderSettings, founderSeatsRemaining, updateFounderSettings, toggleFounderEnrollment, toggleFoundingMember, suspendUser, archiveUser, permanentlyDeleteUser, changeUserTier, sales, pendingSales, pendingListingSales, handleVerifySale, handleVerifyListingSale, handleUnverifyListingSale, handleCancelListingSale, commissionDashboard, promoCodes, newPromo, setNewPromo, createPromoCode, deletePromoCode, promoToDelete, setPromoToDelete, potData, setPotData, updatePot, advertisers, pendingVideos, pendingLibraryVideos, handleBatchApproveVideos, handleVideoReview, handleLibraryVideoReview, moveDownlineData, setMoveDownlineData, featuredMembers, selectedUserToFeature, setSelectedUserToFeature, featuredText, setFeaturedText, handleAddFeaturedMember, handleRemoveFeaturedMember, tierFeatures, editingTier, setEditingTier, editFeatures, setEditFeatures, startEditingTier, saveTierFeatures, customTiers, showTierForm, setShowTierForm, newTier, setNewTier, tierFeaturesInput, setTierFeaturesInput, handleCreateTier, handleDeleteTier, pendingServices, flaggedServices, handleApproveService, handleFlagService, handleDeleteService, edirectoryStatus, syncingEdir, syncEdirectory, importedTransactions, importing, importResult, handleFileSelect, downloadSampleCSV } = props;

  return (
    <div className="space-y-4" data-testid="advertisers-tab">
      <div className="flex justify-between items-center mb-4">
                    <h2 className="text-2xl font-playfair font-bold text-foreground">Advertiser Products</h2>
                    <Link to="/admin/add-advertiser">
                      <Button className="bg-primary text-primary-foreground hover:bg-primary/90" data-testid="add-advertiser-btn">
                        Add New Product
                      </Button>
                    </Link>
                  </div>
            
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {advertisers.map((product) => (
                      <div key={product.id} className="wm-card rounded-lg overflow-hidden" data-testid="advertiser-product">
                        <img src={product.image_url} alt={product.name} className="w-full h-40 object-cover" />
                        <div className="p-4">
                          <h3 className="font-semibold text-foreground">{product.name}</h3>
                          <p className="text-sm text-muted-foreground mt-1">{product.description}</p>
                          <div className="flex items-center justify-between mt-2">
                            <p className="text-lg font-bold text-primary">${product.price.toLocaleString()}</p>
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={async () => {
                                if (!confirm('Remove this ad?')) return;
                                try {
                                  await axios.delete(`${API_URL}/api/admin/advertisers/${product.id}`, { headers: getAuthHeader() });
                                  toast.success('Ad removed');
                                  fetchAllData();
                                } catch (e) {
                                  toast.error('Failed to remove ad');
                                }
                              }}
                              className="text-red-400 hover:text-red-300 hover:bg-red-500/10"
                              data-testid="delete-advertiser-btn"
                            >
                              <Trash2 className="w-4 h-4" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
    </div>
  );
}
